import script from "./Deposit.vue?vue&type=script&lang=ts&setup=true"
export * from "./Deposit.vue?vue&type=script&lang=ts&setup=true"

import "./Deposit.vue?vue&type=style&index=0&id=127a9c80&lang=scss"

const __exports__ = script;

export default __exports__